module.exports = __webpack_public_path__ + "img/15.821f4e7c.png";